import { toJSON } from "../../utils";
// Only set if user owns specific moonpass, allow access without further checking
export class NFTEventTierMoonpassConstraint {
    constructor(params) {
        this.edition = (params === null || params === void 0 ? void 0 : params.edition) || "all";
    }
    get json() {
        return toJSON(this);
    }
}
